import { useContent, useSectionMeta } from "../content/ContentContext";
import { Reveal, Chapter } from "./Reveal";

export const Lessons = () => {
  const { LESSONS, SITE } = useContent();
  const meta = useSectionMeta("lessons");

  return (
    <section id="lessons" className="relative py-24 md:py-36" data-testid="lessons-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Chapter number={meta.number} label={meta.label} id="lessons" />
        </Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
          <Reveal delay={0.08}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight" data-testid="lessons-heading">
              WHAT WE <span className="italic text-gold-light">TALK ABOUT</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-sm text-smoke max-w-xs leading-relaxed">
              The subjects at the heart of every episode.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {LESSONS.map((lesson, i) => (
            <Reveal key={lesson} delay={(i % 5) * 0.07}>
              <div
                className="group relative h-40 md:h-48 border border-white/10 bg-coal/70 rounded-sm overflow-hidden flex items-center justify-center transition-[border-color] duration-500 hover:border-gold/50"
                data-testid={`lesson-card-${lesson.toLowerCase().replace(/[^a-z]/g, "-")}`}
              >
                <div className="absolute inset-0 opacity-[0.07] bg-[radial-gradient(circle_at_30%_20%,#DAA520,transparent_60%)] group-hover:opacity-[0.16] transition-opacity duration-700" />
                <span className="font-display text-lg md:text-xl tracking-[0.18em] text-ivory/90 transition-[opacity,transform] duration-500 group-hover:opacity-0 group-hover:-translate-y-2">
                  {lesson}
                </span>
                <span className="absolute inset-0 flex items-center justify-center px-5 text-center font-quote italic text-sm md:text-base text-gold-light opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                  "{SITE.lessonsHover}"
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
